import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { ReactElement, useRef, useState } from "react";
import { ConfirmPopup } from 'primereact/confirmpopup';
import StateLessGrid from "../../../../components/Shared/StateLessGrid";
import QuickCopyDropdown from "../../../../components/Shared/QuickCopyDropdown";
import { Button } from "primereact/button";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik, FormikProps } from "formik";
import { InputField } from "../../../../components/Shared/InputField";
import { utcDateToLocalDate } from "../../../../utils/Helper";
import { Badge } from "primereact/badge";
import PantheonTransferLogFilter from "./PantheonTransferLogFilter";
import moment from "moment-timezone";
import { ButtonGroup } from "primereact/buttongroup";

const PantheonTransferLogList = (props: any) => {
    const { t, moduleState } = props;
    const [initSearchFormState] = useState<any>({
        search: moduleState.search ?? null
    });
    const [filterPanel, setFilterPanel] = useState<boolean>(false);
    const tableRef: any = useRef();
    const [total, setTotal] = useState(0);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const columns = [
        {
            field: 'invoice', title: t('invoice number'),
            render: (_row: any) => _row.invoice.final_invoice_number
        },
        {
            field: 'status', title: t('status'),
            render: (_row: any) => <>
                { _row.status === "success" &&
                  <Badge severity={ "success" } value={ t('success') } /> }

                { _row.status === "failed" &&
                  <Badge severity={ "danger" } value={ t('failed') } /> }
            </>
        },
        {
            field: 'author', title: t('user'),
            render: (_row: any) => (_row.author || {}).name
        },
        {
            field: 'created_at', title: t('date'),
            render: (_row: any) => utcDateToLocalDate(_row.created_at)
        }
    ];

    const onReset = () => {
        props.setQuery({
            ...moduleState,
            filters: {
                toDate: moment().endOf("year").endOf("day").format("YYYY-MM-DD[T]HH:mm:ss"),
                fromDate: moment().startOf("year").startOf("day").format("YYYY-MM-DD[T]HH:mm:ss"),
            },
            page: 1,
            search: null
        });
    };

    const onSearch = ({ search }: any) => {
        props.setQuery({
            ...moduleState,
            search: search
        });
    };

    const onFilterClick = () => {
        setFilterPanel(true);
    };

    const focusOnSearch = () => {
        const searchInput: HTMLInputElement | null = document.querySelector('input[name="search"]');
        if ( searchInput ) {
            searchInput.focus();
        }
    };

    const DetailRow: any = ({ data }: any): ReactElement => {
        const row = data;

        return (

            <>
                <div style={ { whiteSpace: "break-spaces" } }>
                    <strong className={ 'text-capitalize' }>{ t('request') }:</strong> { row.request }
                </div>
                <div>
                    <strong className={ 'text-capitalize' }>{ t('response') }:</strong> { row.response }
                </div>
            </>
        );
    };

    return (
        <div className={ "block-viewer" }>
            <div className="block-section">
                <div className="block-header">
                    <span className="block-title">
                        <h5 className={ "mb-0" }>{ t('pantheon transfer logs') } ({total})</h5>
                    </span>
                    <div className="block-actions">
                    </div>
                </div>
                <div className="block-content">
                    <Row className={ "p-2" }>
                        <Col
                            sm={ 12 } md={ 6 } className={ "mb-2" }>
                            <Formik
                                enableReinitialize={ true }
                                initialValues={ initSearchFormState }
                                onSubmit={ onSearch }
                            >
                                { (props: FormikProps<any>) => {
                                    return (
                                        <Form onSubmit={ props.handleSubmit }>
                                            <Col sm={ 12 } md={ 8 }>
                                                <Field component={ InputField } withoutLabel={ true }
                                                       autoFocus={ true }
                                                       name="search"
                                                       formGroupClass={ "mb-0" }
                                                       placeholder={ t("search") } />
                                            </Col>
                                        </Form>
                                    );
                                } }
                            </Formik>
                        </Col>

                        <Col
                            sm={ 12 } md={ 6 } className={ "text-right mb-2" }>
                            <div className="d-inline-block me-2 align-middle text-left">
                                <QuickCopyDropdown
                                    columns={ columns }
                                    tableName={ "pantheonsTransferLogList" }
                                    selectedRows={ selectedRows }
                                    trackBy={ "id" }
                                    // @ts-ignore
                                    entities={ tableRef.current?.getEntities?.() || [] }
                                />
                            </div>
                            <ButtonGroup>
                                <Button icon="pi pi-filter-fill" size={ "small" } outlined tooltip={ t('filter') }
                                        onClick={ onFilterClick }
                                        tooltipOptions={ { position: 'top' } } />

                                <Button onClick={ onReset } icon="pi pi-refresh" size={ "small" } outlined
                                        tooltip={ t('reset') }
                                        tooltipOptions={ { position: 'top' } } />
                            </ButtonGroup>
                        </Col>

                        <Col sm={ 12 }>
                            <StateLessGrid
                                size={ "normal" }
                                url={ '/suppliers/transfer/logs/pantheons' }
                                name={ "pantheonsTransferLogList" }
                                columns={ columns }
                                moduleState={ moduleState }
                                setQuery={ props.setQuery }
                                ref={ tableRef }
                                itemSize={ 45 }
                                setTotal={ setTotal }
                                stickyHeader={ true }
                                showQuickCopy={ false }
                                onRowSelection={ setSelectedRows }
                                selectedRows={ selectedRows }
                                detailRow={ (data: any) => <DetailRow data={ data } /> }
                            />
                        </Col>
                    </Row>

                    <PantheonTransferLogFilter
                        moduleState={ moduleState }
                        setQuery={ props.setQuery }
                        toastify={ props.toastify }
                        dropdowns={ props.dropdowns }
                        visibility={ filterPanel }
                        onClose={ () => {
                            setFilterPanel(false);
                            focusOnSearch();
                        } }
                    />

                    <ConfirmPopup />
                </div>
            </div>
        </div>
    );
};

PantheonTransferLogList.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(PantheonTransferLogList));
